import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const NavRoot = styled('div')`
  margin: 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const ConnectBtn = styled('button')`
  border: 0.1px solid #424242;
  background: #000;
  border-radius: 10px;
  padding: 11px;
  font-size: 22px;
  min-width: 150px;
  box-shadow: 2px -1px 1px 0px #fff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  :hover {
    background: #0000;
  }
`;
export const LinkLogo = styled(Link)`
  img {
    min-width: 80px;
  }
`;
